import React from 'react';
import styled from 'styled-components';
import HvSvg from 'src/components/HvSvg';
import {
  NotificationComponentContainer,
  NotificationIconPadding,
} from './styled';

const DisableSelectToolNotificationContainer = styled.div`
  ${NotificationComponentContainer}
`;

const CursorIcon = styled.div`
  ${NotificationIconPadding}
`;

const DisableSelectText = styled.div`
  color: ${({ theme }) => theme.colors.lightGrayFour};
`;

const DisableSelectToolNotification = () => (
  <DisableSelectToolNotificationContainer data-selenium="disableSelectToolNotificationText">
    <CursorIcon>
      <HvSvg src={require('src/assets/images/ic-cursor.svg')} />
    </CursorIcon>
    <DisableSelectText>Select Tool: OFF</DisableSelectText>
  </DisableSelectToolNotificationContainer>
);

export default DisableSelectToolNotification;
